// extracted by mini-css-extract-plugin
export var actions = "_ls-g";
export var benefitCard = "_ls-b";
export var benefitIcon = "_ls-d";
export var benefitLabel = "_ls-f";
export var benefits = "_ls-a";
export var benefitsSection = "_ls-8";
export var bodyText = "_ls-7";
export var closeButton = "_ls-2";
export var content = "_ls-3";
export var eyebrow = "_ls-4";
export var heading = "_ls-5";
export var image = "_ls-i";
export var imagePanel = "_ls-h";
export var modal = "_ls-0";
export var offerCard = "_ls-c";
export var offerIcon = "_ls-e";
export var sectionLabel = "_ls-9";
export var shell = "_ls-1";
export var title = "_ls-6";